import { Modal, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { useState, useRef } from "react";
import CertStoreService from '../../Services/CertStoreService';
import LoadingIndicator from "../CommonComponent/LoadingIndicator";
import { ReactComponent as UploadIcon } from '../../Assets/img/Upload-icon.svg';
import { ReactComponent as Error } from '../../Assets/img/Error.svg';

/**
 * Renders Upload Certificate pop up to upload the global IDA_FIR certificate
 * @component
 * @param {Event} props.onClose() To close pop up
 * @param {Event} props.onShowMessage("message") To show message in pop up
 */
function UploadIdaCert(props) {
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const idaCrtInputRef = useRef();

    let fileReader
    const onChangeHandler = (event) => {
        fileReader = new FileReader();
        fileReader.readAsText(event.target.files[0]);
    };

    function uploadIdaCrtHandler(event) {
        event.preventDefault();
        setIsLoading(true);

        const data = fileReader.result;

        CertStoreService.uploadCert("IDA", data)
            .then((response) => {
                setIsLoading(false);
                if (response.response == null) {
                    setError(response.errors[0].message);
                }
                else {
                    props.onClose();
                    props.onShowMessage("Uploaded Sucessfully");
                }
            })
            .catch((err) => {
                setIsLoading(false);
                setError(err.response?.data?.errors?.[0]?.message || "Upload failed.");
            });
    }

    return (
        <Modal centered={true} show={true} onHide={props.onClose}>
            <ModalHeader style={{ border: "none" }} closeButton>
                <ModalTitle className="Header">
                    <strong>Upload IDA_FIR Certificate</strong>
                </ModalTitle>
            </ModalHeader>
            <Modal.Body style={{ padding: '3%' }}>
                {isLoading ? (
                    <LoadingIndicator size="large" message="Uploading..." />
                ) : (
                    <>
                        {error && (
                            <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>
                        )}
                        <form id="uploadIdaCrtForm" onSubmit={uploadIdaCrtHandler}>
                            <label className="label required">Upload IDA_FIR Certificate:</label>
                            <div>
                                <input className="form-control-file"
                                    type="file" name="file" onChange={onChangeHandler}
                                    ref={idaCrtInputRef}
                                    required
                                />
                            </div>
                        </form>
                    </>
                )}
            </Modal.Body>
            <ModalFooter style={{ border: "none" }}>
                <button type="submit" form="uploadIdaCrtForm" className="primary-button" disabled={isLoading}>
                    <span className="primary-button-icon"><UploadIcon /></span>
                    <span className="primary-button-text">Upload</span>
                </button>
            </ModalFooter>
        </Modal>
    );
}
export default UploadIdaCert;
